import {
  CollegeLogoV2,
  ExamLogoV2,
  CourseLogoV2,
  StudyAbroadLogoV2,
  // NewsLogoV2,
  BlogsLogoV2,
  // ArticleIcon,
  NineDotsSvg,
  InstituteIcon,
} from "@/src/Asset";
import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import DiscoverMobileView from "./component/MobileView/DiscoverMobileView";
import { useMediaQuery } from "usehooks-ts";

const Discover = ({ isTransparent, scroll, isStudyAbroad }: any) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const isLargeScreen = useMediaQuery("(min-width: 1024px)");

  const commonItems = [
    { label: "Colleges", icon: CollegeLogoV2, link: "/colleges-in-india" },
    { label: "Exams", icon: ExamLogoV2, link: "/exams" },
    { label: "Courses", icon: CourseLogoV2, link: "/courses" },
    {
      label: "Institutes ",
      icon: InstituteIcon,
      link: "/institutes/institutes-in-india",
    },

    // { label: "Boards", icon: CourseLogoV2, link: "/boards" },
    // { label: "Scholarship", icon: ScholarshipLogoV2, link: "/scholarships" },
    // { label: "News", icon: NewsLogoV2, link: "/news" },
    // { label: "Articles", icon: ArticleIcon, link: "/articles" },
    { label: "Blogs", icon: BlogsLogoV2, link: "/blogs" },
  ];

  const discoverItems = [
    isStudyAbroad
      ? { label: "India", icon: StudyAbroadLogoV2, link: "/" }
      : {
          label: "Study Abroad",
          icon: StudyAbroadLogoV2,
          link: "/study-abroad",
        },
    ...commonItems,
  ];

  const handleLinkClick = () => {
    setIsDropdownOpen(false);
  };

  return (
    <div
      role="none"
      className={`relative flex items-center gap-x-2 font-inter text-sm font-light lg:ml-6 cursor-pointer h-full ${
        isTransparent && scroll ? "text-white" : "text-black"
      }`}
      onMouseEnter={() => isLargeScreen && setIsDropdownOpen(true)}
      onMouseLeave={() => isLargeScreen && setIsDropdownOpen(false)}
    >
      <NineDotsSvg
        className="text-xl"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      />
      <button
        className={`${
          isTransparent && scroll ? "font-regular" : "font-medium"
        } hidden lg:block`}
      >
        Discover
      </button>
      {/* Desktop Dropdown */}
      <div
        className={`absolute  top-20 -right-20 w-[24rem]  min-h-[13.4rem] bg-white text-black rounded shadow-lg transition-opacity duration-300 py-1.5 px-2 ${
          isDropdownOpen ? "lg:opacity-100 lg:block hidden" : "opacity-0 hidden"
        }`}
      >
        <div
          className={`absolute top-[-12px] right-[30%] translate-x-[50%] w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[12px] border-b-white`}
        ></div>
        <p className="text-primary text-sm font-inter font-bold">Discover</p>
        <ul className="grid grid-cols-2 gap-x-4 gap-y-2 mt-5">
          {discoverItems?.map((item, index) => (
            <li
              key={item.label}
              className={`flex items-center gap-2 pb-1 w-full max-w-36 hover:bg-gray-100 hover:rounded-lg ${
                index < discoverItems.length - 2 ? "border-b" : ""
              }`}
            >
              <Link href={item.link} onClick={handleLinkClick}>
                <div className="flex items-center gap-2">
                  <Image
                    src={item.icon}
                    alt={`Explore ${item.label}`}
                    width={300}
                    height={300}
                    className="w-7 h-7 object-center object-fill"
                  />
                  <span className="font-inter font-medium text-sm text-primary">
                    {item.label}
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Mobile Dropdown */}
      <DiscoverMobileView
        isDropdownOpen={isDropdownOpen}
        setIsDropdownOpen={setIsDropdownOpen}
        discoverItems={discoverItems}
        handleLinkClick={handleLinkClick}
      />
    </div>
  );
};

export default Discover;
